export const PATHS = {
  BASE: '/',
  HOME: '/',
  DATA: '/data',
  COMMERCE_ADMIN: '/environments/admin/commerce',
  LAUNCH_ADMIN: '/environments/admin/launch',
  ORG_ADMIN: '/environments/admin/org',
  AEP_ADMIN_CONFIGURE: '/environments/admin',
  AEP_DETAILS: '/environments/aep',
  QUICK_SETUP: '/quick-setup',
  TOOLS: '/tools'
};

export const INTEGRATIONS = {
  ACTIONS_BASE_URL:
    'https://adobeioruntime.net/api/v1/web/demoteam/demo-system',
  CONFIGURE_AEP_ACTION: 'configure-aep',
  CONFIGURE_LAUNCH_ACTION: 'configure-launch',
  CONFIGURE_ACS_ACTION: 'configure-acs',
  CONFIGURE_MARKETO_ACTION: 'configure-marketo',
  VALIDATE_AEP_ACTION: 'validate-aep',
  VALIDATE_TARGET_ACTION: 'validate-target',
  VALIDATE_JO: 'validate-jo'
};

export const ENVIRONMENT_TYPES = {
  adobe: [
    {
      name: 'imsOrg',
      title: 'IMS Organization',
      image:
        'https://demo-system-next.s3.eu-north-1.amazonaws.com/logos/experience-cloud.svg',
      disabled: true
    },
    {
      name: 'aepSandbox',
      title: 'AEP Sandbox',
      image:
        'https://demo-system-next.s3.eu-north-1.amazonaws.com/logos/aep.svg',
      disabled: true
    }
  ],
  thirdParty: [
    {
      name: 'dynamics',
      title: 'Dynamics 365',
      type: 'CRM',
      image:
        'https://demo-system-next.s3.eu-north-1.amazonaws.com/logos/dynamics.png'
    },
    {
      name: 'salesforce',
      title: 'Salesforce',
      type: 'CRM',
      image:
        'https://demo-system-next.s3.eu-north-1.amazonaws.com/logos/salesforce.svg'
    },
    {
      name: 'servicenow',
      title: 'ServiceNow',
      type: 'Workflow',
      image:
        'https://demo-system-next.s3.eu-north-1.amazonaws.com/logos/servicenow.svg'
    }
    // {
    //   name: 'pega',
    //   title: 'Pega',
    //   type: 'Decisioning',
    //   image:
    //     'https://demo-system-next.s3.eu-north-1.amazonaws.com/logos/pega.png',
    //   disabled: true
    // }
  ]
};

export const AEP_CONFIGURATIONS = [
  {
    name: 'rendezvous-v1.0',
    title: 'Rendezvous v1.0',
    description: 'For testing purposes only',
    aep: {
      configName: 'rendezvous-v1.0'
    },
    launch: {
      webConfig: 'rendezvous-web-1.0',
      implementation: 'nitrogen',
      createEdgeConfiguration: true
      // mobileConfig: 'rendezvous-mobile-v1.0'
    },
    visible: ['zkorczyc', 'hannouz', 'vangeluw', 'bsoin', 'mcintyre'],
    default: false
  },
  {
    name: 'retail-v1.1',
    title: 'Retail v1.1',
    description:
      'This configuration is an implementation of Common Data Model for AEP and will also create Launch properties for streaming website/mobile app data into AEP. It lets you demonstrate Unified Profile, RTCDP, Journey Orchestration and Streaming segmentation scenarios.',
    aep: {
      configName: 'retail-v1.1'
    },
    launch: {
      webConfig: 'retail-web-v1.1',
      mobileConfig: 'retail-mobile-v1.1.1'
    },
    visible: false,
    default: false
  },
  {
    name: 'retail-v2.1',
    title: 'Retail v2.1',
    description:
      'This configuration is an implementation of Common Data Model for AEP for Retail vertical. It will also create Launch properties for streaming website/mobile app data into AEP. It lets you demonstrate Unified Profile, RTCDP, Journey Orchestration, Offer Decisioning and streaming segmentation scenarios.',
    aep: {
      configName: 'retail-v1.2'
    },
    launch: {
      webConfig: 'retail-web-v2.1',
      mobileConfig: 'retail-mobile-v2.0',
      implementation: 'nitrogen',
      createEdgeConfiguration: true
    },
    ode: 'true',
    jo: {
      journeys: [
        {
          name: 'Retail Registration',
          url: 'https://contentviewer.s3.amazonaws.com/elements/csv/jo/retail-v1.2/retail-registration.json'
        },
        {
          name: 'Retail - Store Entry',
          url: 'https://contentviewer.s3.amazonaws.com/elements/csv/jo/retail-v1.2/retail-store-entry.json'
        },
        {
          name: 'Retail - Store Exit',
          url: 'https://contentviewer.s3.amazonaws.com/elements/csv/jo/retail-v1.2/retail-store-exit.json'
        },
        {
          name: 'Retail - POI Entry',
          url: 'https://contentviewer.s3.amazonaws.com/elements/csv/jo/retail-v1.2/retail-POI-Entry.json'
        },
        {
          name: 'Luma Registration',
          url: 'https://contentviewer.s3.amazonaws.com/elements/csv/jo/retail-v1.2/lumaRegistration.json'
        }
      ]
    },
    visible: true,
    default: true
  },
  {
    name: 'external-retail-v2.1',
    title: 'Retail v2.1 for External Website',
    description:
      'Same as Retail v2.1 but for use on any external website through injection of Launch property.',
    learnMoreLink: 'https://docs.adobedemo.com/profile-viewer/overview',
    aep: {
      configName: 'retail-v1.2'
    },
    launch: {
      webConfig: 'aep-retail-external',
      implementation: 'nitrogen',
      createEdgeConfiguration: true
    },
    argon: {
      projects: [
        {
          label: 'External Website',
          template: 'external-website/generic-retail-v1',
          description:
            'This will allow you to easily customize the Profile Viewer panel - decide which profile attributes and experience events to display.',
          defaultSelected: true,
          disabled: true,
          type: 'web'
        }
      ]
    },
    visible: true,
    default: false
  },
  {
    name: 'external-global-v1.1',
    title: 'Global v1.1 for External Website',
    description:
      'Configuration for use on any external website through injection of Launch property compatible with Enablement environment.',
    learnMoreLink: 'https://docs.adobedemo.com/profile-viewer/overview',
    aep: {
      configName: 'emea-enablement-v1.2'
    },
    launch: {
      webConfig: 'aep-global-external',
      implementation: 'nitrogen',
      createEdgeConfiguration: true
    },
    argon: {
      projects: [
        {
          label: 'External Website',
          template: 'external-website/generic-retail-v1',
          description:
            'This will allow you to easily customize the Profile Viewer panel - decide which profile attributes and experience events to display.',
          defaultSelected: true,
          disabled: true,
          type: 'web'
        }
      ]
    },
    visible: true,
    default: false
  },
  {
    name: 'fsi-v1.0',
    title: 'FSI v1.0',
    description:
      'This configuration is an implementation of Common Data Model for AEP for FSI vertical. It will also create Launch properties for streaming website/mobile app data into AEP. It lets you demonstrate Unified Profile, RTCDP, Journey Orchestration and Streaming segmentation scenarios.',
    aep: {
      configName: 'fsi-v1.0'
    },
    launch: {
      webConfig: 'fsi-web-v1.0',
      mobileConfig: 'fsi-mobile-v1.0'
    },
    data: {
      description: 'Website events and CRM profiles'
    },
    visible: false,
    default: false
  },
  {
    name: 'fsi-v2.0',
    title: 'FSI v2.0',
    description:
      'Same as FSI 1.0 but version 2.0 uses the Web SDK for Experience Events.',
    aep: {
      configName: 'fsi-v1.0'
    },
    launch: {
      webConfig: 'fsi-web-v2.0',
      mobileConfig: 'fsi-mobile-v2.0',
      implementation: 'nitrogen',
      createEdgeConfiguration: true
    },
    data: {
      description: 'Website events and CRM profiles'
    },
    visible: true,
    default: false
  },
  {
    name: 'emea-enablement-v1.1',
    title: 'Team International AEP Enablement Environment v1.1',
    description:
      'Enablement environment with support for Retail, FSI, Telco, FMCG, Travel and Media & Entertainment, based on the AEP enablement content and environment by Wouter Van Geluwe and team.',
    aep: {
      configName: 'emea-enablement-v1.0'
    },
    launch: {
      webConfig: 'emea-enablement-web-v1.1',
      mobileConfig: 'emea-enablement-mobile-v1.0',
      implementation: 'nitrogen',
      createEdgeConfiguration: false
    },
    visible: false
  },
  {
    name: 'emea-enablement-v1.2',
    title: 'Team International AEP Enablement FY21 v1.2',
    description:
      'Enablement environment with support for Retail, FSI, Telco, FMCG, Travel and Media & Entertainment, based on the AEP enablement content and environment by Wouter Van Geluwe and team.',
    aep: {
      configName: 'emea-enablement-v1.2',
      variants: ['core'],
      implementation: 'nitrogen'
    },
    launch: {
      webConfig: 'emea-enablement-web-v1.2',
      mobileConfig: 'emea-enablement-mobile-v1.2',
      implementation: 'nitrogen',
      createEdgeConfiguration: false
    },
    visible: true
  },
  {
    name: 'retail-v1.2',
    title: 'Retail v1.2 (legacy)',
    description:
      'This configuration is an implementation of Common Data Model for AEP for Retail vertical. It will also create Launch properties for streaming website/mobile app data into AEP. It lets you demonstrate Unified Profile, RTCDP, Journey Orchestration and Streaming segmentation scenarios. Version 1.2 includes Data Capture Mixin, JO Test profiles mixin, Chatbot mixin',
    aep: {
      configName: 'retail-v1.2'
    },
    launch: {
      webConfig: 'retail-web-v1.2',
      mobileConfig: 'retail-mobile-v1.2'
    },
    ode: 'true',
    jo: {
      journeys: [
        {
          name: 'Retail Registration',
          url: 'https://contentviewer.s3.amazonaws.com/elements/csv/jo/retail-v1.2/retail-registration.json'
        },
        {
          name: 'Retail - Store Entry',
          url: 'https://contentviewer.s3.amazonaws.com/elements/csv/jo/retail-v1.2/retail-store-entry.json'
        },
        {
          name: 'Retail - Store Exit',
          url: 'https://contentviewer.s3.amazonaws.com/elements/csv/jo/retail-v1.2/retail-store-exit.json'
        },
        {
          name: 'Retail - POI Entry',
          url: 'https://contentviewer.s3.amazonaws.com/elements/csv/jo/retail-v1.2/retail-POI-Entry.json'
        },
        {
          name: 'Luma Registration',
          url: 'https://contentviewer.s3.amazonaws.com/elements/csv/jo/retail-v1.2/lumaRegistration.json'
        }
      ]
    },
    visible: true,
    default: false
  }
];
